import Line from "components/common/Scheduler/SchedulerRenderers/components/Line";
import React from "react";
import renderToString from "./renderToString";

export default function lineRenderer() {
  return ({ cellElement, record }) => renderToString(<Line cellElement={cellElement} record={record} />);
}
